import ObjectTypeRepository from './objectTypesRepository'

export default {
    ObjectTypeRepository
}
